import { batch } from "@preact/signals-react"
import { utgListFiltersValueSignal, taskListFiltersValueSignal, deviceListFiltersValueSignal, pageSizeSignal, showSidebarSignal, sidebarWidthSignal, debugSignal, selectedBusinessEntityIdSignal } from "../signals/userSettingsSignals"

export const removeUtgListFilter = () => { utgListFiltersValueSignal.value = null }
export const removeTaskListFilter = () => { taskListFiltersValueSignal.value = null }
export const removeDeviceListFilter = () => { deviceListFiltersValueSignal.value = null }
export const clearFilters = () => {
    batch(() => {
        utgListFiltersValueSignal.value = null
        taskListFiltersValueSignal.value = null
        deviceListFiltersValueSignal.value = null
    })
}

export const updateUtgListFilter = (filter) => { utgListFiltersValueSignal.value = filter }
export const updateTaskListFilter = (filter) => { taskListFiltersValueSignal.value = filter }
export const updateDeviceListFilter = (filter) => { deviceListFiltersValueSignal.value = filter }

export const updatePageSize = (pageSize) => { pageSizeSignal.value = pageSize }

export const updateShowSidebar = (flag) => { showSidebarSignal.value = flag }
export const updateSidebarWidth = (width) => { sidebarWidthSignal.value = width }

export const updateDebug = (flag) => { debugSignal.value = flag }

export const updateSelectedBusinessEntityId = (id) => { selectedBusinessEntityIdSignal.value = id }
export const removeSelectedBusinessEntityId = () => { selectedBusinessEntityIdSignal.value = null }